import React, { ReactElement } from "react"
import IndexPage from "."

const NotFoundPage: React.FC = (): ReactElement => {
  return <IndexPage />
}

export default NotFoundPage
